import type { BindingTab, UserPageMode } from '../types';

export const BINDING_USER_TITLES: Record<BindingTab, Record<UserPageMode, string>> = {
	farmers: {
		add: 'Novo Agricultor',
		edit: 'Editar Agricultor',
		view: 'Informações do Agricultor',
	},
	consultants: {
		add: 'Novo Consultor',
		edit: 'Editar Consultor',
		view: 'Informações do Consultor',
	},
};

export const BINDING_USER_SUBTITLES: Record<UserPageMode, Record<BindingTab, string>> = {
	add: {
		farmers: 'Cadastre os dados pessoais do novo agricultor',
		consultants: 'Cadastre os dados pessoais do novo consultor',
	},
	edit: {
		farmers: 'Edite os dados pessoais do agricultor',
		consultants: 'Edite os dados pessoais do consultor',
	},
	view: {
		farmers: 'Visualize os dados pessoais do agricultor',
		consultants: 'Visualize os dados pessoais do consultor',
	},
};

export const BINDING_USER_SECTION_TITLES: Record<BindingTab, string> = {
	farmers: 'IDENTIFICAÇÃO DO AGRICULTOR',
	consultants: 'IDENTIFICAÇÃO DO CONSULTOR',
};

export const USER_TITLES: Record<UserPageMode, string> = {
	add: 'Novo Usuário',
	edit: 'Editar Usuário',
	view: 'Informações do Usuário',
};

export const USER_SUBTITLES: Record<UserPageMode, string> = {
	add: 'Cadastre os dados pessoais do novo usuário',
	edit: 'Edite os dados pessoais do usuário',
	view: 'Visualize os dados pessoais do usuário',
};

export const USER_SECTION_TITLE = 'IDENTIFICAÇÃO DO USUÁRIO';
